// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth} from 'firebase/auth';
import { getStorage } from 'firebase/storage';


const firebaseConfig = {
  apiKey: "AIzaSyACATo2AzF_DLqWuGmDkgIWCinCFs9LXps",
  authDomain: "unitee-75d87.firebaseapp.com",
  projectId: "unitee-75d87",
  storageBucket: "unitee-75d87.firebasestorage.app",
  messagingSenderId: "731176975373",
  appId: "1:731176975373:web:4798402becc0faeeab2944",
  measurementId: "G-WYVZY7GCLV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const Storage = getStorage(app);


export { db, auth, Storage };
